import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Button, Modal, Spinner, Stack } from "react-bootstrap"
import ReauthenticationForm from "@components/Settings/ReauthenticationForm.tsx"
import useMfaDisable from "@views/Settings/useMfaDisable.ts"
import OtpInput from "@components/Mfa/OtpInput.tsx"

const MultiFactorDisableModal = () => {
	const {
		step,
		isLoading,
		onNextStep,
		getNextStepButtonLabel,
		otpCode,
		password,
		onPasswordChange,
		onOtpCodeChange,
		isRecoveryMode,
		toggleRecoveryMode,
	} = useMfaDisable()

	const { t } = useTranslation()
	const navigate = useNavigate()

	const formSteps = [
		<ReauthenticationForm key="reauth-password-form" onPasswordChange={onPasswordChange} password={password} />,
		<OtpReauthenticationForm
			key="reauth-password-form"
			onOtpChange={onOtpCodeChange}
			otp={otpCode}
			isRecoveryMode={isRecoveryMode}
			toggleRecoveryMode={toggleRecoveryMode}
		/>,
	]

	return (
		<Modal show={true} onHide={() => navigate("/settings")} size="lg" centered>
			<Stack className="p-5 " direction="vertical">
				{formSteps[step]}

				<Stack className="justify-content-end pt-4" direction="horizontal" gap={2}>
					<Button variant="secondary" onClick={() => navigate("/settings")}>
						{t("Peruuta")}
					</Button>
					<Button variant="primary" onClick={onNextStep}>
						{isLoading ? <Spinner as="span" animation="border" size="sm" /> : getNextStepButtonLabel()}
					</Button>
				</Stack>
			</Stack>
		</Modal>
	)
}

interface OtpReauthenticationFormProps {
	otp: string
	onOtpChange: (password: string) => void
	toggleRecoveryMode: () => void
	isRecoveryMode: boolean
}

function OtpReauthenticationForm({ onOtpChange, otp, isRecoveryMode, toggleRecoveryMode }: OtpReauthenticationFormProps) {
	const { t } = useTranslation()

	return (
		<>
			<h2>{t("Poista monivaiheinen tunnistautuminen käytöstä")}</h2>
			<p className="mt-2">
				{t("Vahvista monivaiheisen tunnistautumisen pois kytkentä tunnuslukusovelluksen koodilla.")}
				<Button variant="link" className="p-0" onClick={toggleRecoveryMode}>
					{isRecoveryMode ? t("Käytä tunnuslukusovellusta") : t("Käytä palautuskoodia")}
				</Button>
			</p>

			<OtpInput value={otp} onChange={onOtpChange} type={isRecoveryMode ? "recovery" : "authenticator"} shouldAutoFocus />
		</>
	)
}

export default MultiFactorDisableModal
